import request from '@/utils/request'

/**
 * 查询编辑器类型列表
 * @param {Object} params 
 * @returns 
 */
export function findEditorTypeList(params) {
  return request({
    url: '/device/editor/type/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询类型列表
 * @param {Object} params 
 * @returns 
 */
export function findTypeList(params) {
  return request({
    url: '/device/type/list',
    method: 'GET',
    params,
  })
}

/**
 * 根据场景id查询类型列表
 * @param {Object} params 
 * @returns 
 */
export function findTypeListBySceneId(params) {
  return request({
    url: '/device/type/listBySceneId',
    method: 'GET',
    params,
  })
}

/**
 * @param {Object} params 
 * @returns 
 */
export function findStructAllInfo(params) {
  return request({
    url: '/device/struct/info',
    method: 'GET',
    params,
  })
}

/**
 * 添加定义
 * @param {Object} data 
 * @returns 
 */
export function saveDefine(data) {
  return request({
    url: '/device/saveDeviceDefine',
    method: 'post',
    data,
  })
}

/**
 * 修改定义
 * @param {Object} data 
 * @returns 
 */
export function editDefine(data) {
  return request({
    url: '/device/basic/property',
    method: 'put',
    data,
  })
}

/**
 * 保存设备类型
 * @param {Object} data 
 * @returns 
 */
export function saveDiviceType(data) {
  return request({
    url: '/device/saveDiviceType',
    method: 'post',
    data,
  })
}
/**
 * 保存设备树节点数据
 * @param {Object} data 
 * @returns 
 */
export function saveTreeData(data) {
  return request({
    url: '/device/saveTreeData',
    method: 'post',
    data,
  })
}
/**
 * 获取设备树节点数据
 * @param {Object} data 
 * @returns 
 */
export function queryTreeData(params) {
  return request({
    url: '/device/treeData',
    method: 'get',
    params,
  })
}

/**
 * 移除定义类型
 * @param {Object} data { id: '' } 
 * @returns 
 */
export function removeType(id) {
  return request({
    url: '/device/type/remove',
    method: 'post',
    data: {
      id,
    },
  })
}



